import { Injectable } from '@angular/core';
import { AuthUser } from '../../shared/models/auth-user';

declare let window;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private loaded = false;

  constructor() {}

  initialize() {
    this.loaded = true;
  }

  addEvent(name: string, data: any) {
    if (this.loaded) {
      window.gtag('event', name, data);
    } else {
      setTimeout(() => {
        this.addEvent(name, data);
      }, 100);
    }
  }

  addLogin(user: AuthUser) {
    if (this.loaded) {
      window.gtag('set', { user_id: user.sub });
    }
  }
}
